
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22 14.667v4.889A2.444 2.444 0 0119.556 22H17.11a1.222 1.222 0 01-1.222-1.222v-7.334a1.222 1.222 0 011.222-1.222V8.556a6.11 6.11 0 10-12.222 0v3.666a1.222 1.222 0 011.222 1.222v7.334A1.222 1.222 0 014.89 22H2.444A2.444 2.444 0 010 19.556v-4.89a2.444 2.444 0 012.444-2.444V8.556a8.556 8.556 0 0117.112 0v3.666A2.444 2.444 0 0122 14.667z"}})])
          )
        }
      }
    